<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="sAPCustomerMaterialMapping.pkid > 0 ? '编辑':'新建'"
      class="customer-edit"
      width="800px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="sAPCustomerMaterialMapping"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <div>
        <el-form-item label="客户" prop="customerName">
          <div style="display: flex;flex-direction: row;">
            <el-input v-model="sAPCustomerMaterialMapping.customerName" placeholder="请输入" clearable>
              <el-button slot="append" icon="el-icon-search" style="margin-left: 2%;" @click="$refs.selectCustomer.open()">选择</el-button>
            </el-input>
            <customer-select ref="selectCustomer" @select="selectCustomer"/>
          </div>
        </el-form-item>
        <div class="vm-separate">
          <el-form-item label="客户物料编号" prop="customerMaterialNo">
            <el-input v-model="sAPCustomerMaterialMapping.customerMaterialNo" clearable placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="客户物料单位">
            <el-input v-model="sAPCustomerMaterialMapping.unit" clearable placeholder="请输入"/>
          </el-form-item>
        </div>
        <el-form-item label="客户物料描述" prop="customerMaterialDesc">
          <el-input v-model="sAPCustomerMaterialMapping.customerMaterialDesc" clearable placeholder="请输入"/>
        </el-form-item>
        <div class="vm-separate">
          <el-form-item label="SAP物料编号">
            <div style="display: flex;flex-direction: row;">
              <el-input v-model="sAPCustomerMaterialMapping.materialNo" placeholder="请输入" clearable @clear="clearInput">
                <el-button slot="append" icon="el-icon-search" style="margin-left: 2%;" @click="$refs.selectMateriaManagement.open()">选择</el-button>
              </el-input>
              <material-management-select ref="selectMateriaManagement" @select="selectMateriaManagement"/>
            </div>
          </el-form-item>
          <el-form-item label="单价">
            <el-input v-model="sAPCustomerMaterialMapping.price" clearable placeholder="请输入"/>
          </el-form-item>
        </div>
        <el-form-item label="SAP物料描述">
          <el-input v-model="sAPCustomerMaterialMapping.materialDesc" readonly placeholder="请输入"/>
        </el-form-item>
        <div class="vm-separate">
          <el-form-item label="销售国家" prop="salesCountry">
            <el-radio-group v-model="sAPCustomerMaterialMapping.salesCountry">
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="10">国内</el-radio>
              <el-radio :label="20">海外</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="箱号">
            <el-input v-model="sAPCustomerMaterialMapping.packageNo" clearable placeholder="请输入"/>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>

  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import MaterialManagementSelect from "@/views/information/MaterialManagement/MaterialManagementSelect";
  export default {
    name:"SAPCustomerMaterialMappingEdit",
    components: {MaterialManagementSelect, CustomerSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        sAPCustomerMaterialMapping: {
          pkid: "",
          customerNo: "",
          customerName: "",
          packageNo: "",
          materialDesc: "",
          materialNo: "",
          customerMaterialNo: "",
          customerMaterialDesc: "",
          unit: "",
          price: null,
          sapUnit: "",
          salesCountry: 10,
          salesOrgan: "",
          salesChannel: "",
          createType: 10,
        },
        ruleValidate: {
          customerName: {required: true, message: "不能为空",trigger: "blur"},
          customerMaterialNo: {required: true, message: "不能为空",trigger: "blur"},
          customerMaterialDesc: {required: true, message: "不能为空",trigger: "blur"},
          salesCountry: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        console.log(id);
        this.sAPCustomerMaterialMapping.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `SAPCustomerMaterialMappings/${this.sAPCustomerMaterialMapping.pkid}`)
          .then(resp => {
            console.log(resp);
            this.sAPCustomerMaterialMapping = resp;
          });
      },
      clearInput() {
        this.sAPCustomerMaterialMapping.materialDesc = "";
        this.sAPCustomerMaterialMapping.materialNo = "";
        this.sAPCustomerMaterialMapping.sapUnit = "";
      },
      selectCustomer(row) {
        this.sAPCustomerMaterialMapping.customerName = row.customerName;
        this.sAPCustomerMaterialMapping.customerNo = row.outerNo;
      },
      selectMateriaManagement(row) {
        console.log(row);
        this.sAPCustomerMaterialMapping.materialNo = row.no;
        this.sAPCustomerMaterialMapping.materialDesc = row.name;
        this.sAPCustomerMaterialMapping.sapUnit = row.unit;
      },
      handleSubmit() {
        if(this.sAPCustomerMaterialMapping.pkid>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "SAPCustomerMaterialMappings", this.sAPCustomerMaterialMapping)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "SAPCustomerMaterialMappings", this.sAPCustomerMaterialMapping)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
